function onKeyUpEscape(event) {
  const mediaQueryDesktop = window.matchMedia('(min-width: 1001px)');
  if (mediaQueryDesktop.matches) { 
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', 'false');
    summaryElement.focus();
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function countActiveFilters() {
  const activeFilters = document.querySelectorAll('.facet-checkbox input:checked');
  return activeFilters.length;
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.removeEventListener('keyup', onKeyUpEscape);
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

     // Add the sortTrigger and sortForm elements
     this.sortTrigger = document.getElementById('facetsSort');
     this.sortForm = document.getElementById('facetsSortOptions');
     this.filterTrigger = document.getElementById('filter-dd-trigger');

     // Add event listeners
     this.sortTrigger.addEventListener('click', this.toggleClassOnSortForm.bind(this));
     this.filterTrigger.addEventListener('click', this.toggleClassOnFilterForm.bind(this));
  }

    // Add the toggleClassOnFilterForm and toggleClassOnSortForm methods
    toggleClassOnFilterForm() {
      const filterForm = document.getElementById('FacetsWrapperDesktop');
      const firstFilter = document.querySelector('.facets__disclosure');
      filterForm.classList.toggle('hidden-mobile');
      this.filterTrigger.classList.toggle('open');
      firstFilter.setAttribute('open', '');
    }

    toggleClassOnSortForm() {
      const filterCaret = document.querySelector('.facet-filters__caret');
        filterCaret.classList.toggle('open');
        this.sortTrigger.classList.toggle('open');
        this.sortForm.classList.toggle('hidden');
    }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    function reloadScriptWithCacheBuster() {
      const oldScript = document.getElementById('coreJS');

      if (!oldScript) {
          console.error('Script with ID "coreJS" not found.');
          return;
      }

      const scriptSrc = oldScript.src;
      const cacheBuster = new Date().getTime();
      const newSrc = scriptSrc.includes('?')
          ? scriptSrc.split('?')[0] + '?' + cacheBuster
          : scriptSrc + '?' + cacheBuster;

      oldScript.remove();
      const newScript = document.createElement('script');
      newScript.src = newSrc;
      newScript.id = 'coreJS';

      const dataAttributes = Array.from(oldScript.attributes).filter(attr => attr.name.startsWith('data-'));
      dataAttributes.forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
      });

      document.body.appendChild(newScript);
  }


    sections.forEach((section) => {
      const url = `${window.location.pathname}?${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
      setTimeout(reloadScriptWithCacheBuster, 750);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderCustomSorting(){

      const liElements = document.querySelectorAll('.form-field-select.list .option-decoy');
      const selectElement = document.querySelector('#SortBy');
      const selectValueDisplay = document.querySelector('#facetsSort');
      const selectValueDisplayState = document.querySelector('#facetsSort[data-state]');
      const selectValuelist = document.querySelector('#facetsSortOptions');
      const sortWrap = document.querySelector('.facet-filters');
      const filterCaret = document.querySelector('.facet-filters__caret');

      liElements.forEach((li, index) => {
        li.addEventListener('click', (e) => {
            const optionElements = document.querySelectorAll('select.form-field-select option');          
            const optionArray = Array.from(optionElements);

            // Check if the associated option for the clicked li has the selected=true or selected=selected
            const selectedValue = optionArray[index].getAttribute('selected');
            if (selectedValue === 'true' || selectedValue === 'selected') {
                return; // Return early to not execute the rest of the code
            }

            optionArray.forEach(option => {
                option.setAttribute('selected', 'false')
            });

            optionArray[index].setAttribute('selected', 'true');
            selectElement.value = e.target.getAttribute('value');

            let form = document.getElementById("FacetFiltersForm");
            const formData = new FormData(form);
            let searchparams = new URLSearchParams(formData).toString();
            FacetFiltersForm.renderPage(searchparams, e);
            closeSortBy();
        });
    });

      function closeSortBy() {
          selectValueDisplayState.setAttribute('data-state', 'closed');
          selectValuelist.classList.add('hidden');
          selectValueDisplay.classList.remove('open');
          selectValueDisplay.classList.add('closed');
          filterCaret.classList.remove('open');
      }

      function openSortBy() {
          selectValueDisplayState.setAttribute('data-state', 'open');
          selectValuelist.classList.remove('hidden');
          selectValueDisplayState.classList.add('open');
          selectValueDisplayState.classList.remove('closed');
          filterCaret.classList.add('open');
          let selectValueDisplay = document.querySelector('#facetsSort');
      }

      selectValueDisplay.addEventListener('click', (event) => {
          event.stopPropagation();
          if (selectValueDisplayState.getAttribute('data-state') === 'closed') {
              openSortBy();
          }
      });

      document.addEventListener('keydown', function(event) {
          event.stopPropagation();
          if ((event.key === 'Escape') && (selectValueDisplayState.getAttribute('data-state') === 'open')) {
              closeSortBy()
          }
      });

      document.addEventListener('click', function(event) {
          event.stopPropagation();
          if (selectValueDisplayState.getAttribute('data-state') === 'open' && !sortWrap.contains(event.target)) {
              closeSortBy()
          }
      });


      const sortByValue = document.querySelector('.sortby-value');  
      const selectedOption = document.querySelector('.form-field-select option[selected="true"]');
      sortByValue.textContent = selectedOption ? selectedOption.textContent : '';

      const optionDecoys = document.querySelectorAll('.option-decoy');
      optionDecoys.forEach(decoy => {
        decoy.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          optionDecoys.forEach(otherDecoy => {
            if (otherDecoy !== decoy) {
              otherDecoy.removeAttribute('selected');
            }
          });
          decoy.setAttribute('selected', 'true');
          sortByValue.textContent = decoy.innerHTML.trim();
        });
      });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderCustomSorting();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    document.querySelector("#remove_button_wrapper").innerHTML = parsedHTML.querySelector("#remove_button_wrapper").innerHTML

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;
      const currentActiveID = document.activeElement.id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newElementToActivate = document.getElementById(currentActiveID);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }

    const activeFilterCount = FacetFiltersForm.countActiveFilters();
    const totalActiveFilterElement = document.querySelector('.facets__activated'); 
    if (totalActiveFilterElement) {
      totalActiveFilterElement.textContent = `(${activeFilterCount})`;
      if (activeFilterCount > 0) {
        totalActiveFilterElement.classList.remove('hidden');
      } else { 
        totalActiveFilterElement.classList.add('hidden');
      }
    }
  }

  static countActiveFilters() {
    const activeFilters = document.querySelectorAll('.facet-checkbox input:checked');
    return activeFilters.length / 2;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.renderCustomSorting();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.boundCloseFilter = this.closeFilter.bind(this);
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.setAttribute('aria-label', 'Remove facet'); 
    facetLink.setAttribute('tabindex', '0');
    facetLink.removeEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('click', this.closeFilter.bind(this));    
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE') {
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    const filterCount = document.querySelector('.facets__activated');
    // set the filter count to 0 and add the hidden class
    filterCount.textContent = '(0)';
    filterCount.classList.add('hidden');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);